// Importing React/Redux/Third party Library components
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ActionCard from './action-card'
// Importing style component
import {
  StyledCardName,
  StyledCardLabel,
  StyledPadCardFooter,
  StyledPadCardDeailsDiv,
  StyledRoutingNumber,
} from './atoms'
// Importing common module component
import { StyledReason } from 'portal-modules/common/components/atoms'
import displayMaskedNumber from 'portal-modules/common/utils/display-masked-number'
import styled from '@emotion/styled'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import PendingAutomaticAuthorization from 'portal-modules/common/components/PendingAutomaticAuthorization'

const StyledActionCard = styled(ActionCard)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  opacity: ${({ disabled }) => (disabled ? 0.8 : 1)};
  background: ${({ disabled, theme }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : disabled
        ? theme.gray.light
        : theme.mode.isDark
          ? theme.mode.card_background_color
          : theme.backgroundColor.white};
`

//Card Component for the Bacs payment method
export const BacsCard = ({
  nickname,
  cardLabel,
  bank_info: { routing_number, account_number_masked, mandate_status },
  Icon,
  onDelete,
  onEdit,
  paymentTypeId,
  isFromWallet,
  relinkAccountId,
  refundPlaidItemError,
  refund_plaid_verification_status,
  isAddAutoPaymentAllowed,
  isDeleteAutoPaymentAllowed,
  isEditAutoPaymentAllowed,
  deletePaymentMethodAccess,
  addPaymentMethodAccess,
  editPaymentMethodAccess,
  isScreeningEnabled,
  isScreeningValidationEnabled,
  disableFlexPaymentAccount,
  ...rest
}) => {
  //Disabling edit and delete for Bacs payment method
  let isDisabled = false
  let isDisableEdit = false
  let isDisableDelete = false
  let strDisableMessage = null
  let warningMessage = null

  const getName = () => {
    return nickname?.length > 18 ? `${nickname?.slice(0, 18)}...` : nickname
  }

  let disable_bacs_payment_account = mandate_status == 'pending' ?? false

  if (disable_bacs_payment_account) {
    isDisableEdit = isDisabled = isDisableDelete = true
    strDisableMessage = __('Bacs mandate pending')
    warningMessage = 'disable_bacs_payment_account'
  }

  return (
    <StyledActionCard
      {...rest}
      isFromWallet={isFromWallet}
      onDelete={isDisableDelete ? null : onDelete}
      onEdit={isDisableEdit ? null : onEdit}
      disabled={isDisabled}
      title={
        <Fragment>
          <Icon size={'40px'} style={{ marginTop: '-20px' }} />
          <StyledCardLabel>{cardLabel}</StyledCardLabel>
        </Fragment>
      }
      isAddAutoPaymentAllowed={isAddAutoPaymentAllowed}
      isEditAutoPaymentAllowed={isEditAutoPaymentAllowed}
      isDeleteAutoPaymentAllowed={isDeleteAutoPaymentAllowed}
      deletePaymentMethodAccess={deletePaymentMethodAccess}
      editPaymentMethodAccess={editPaymentMethodAccess}
      addPaymentMethodAccess={addPaymentMethodAccess}
    >
      <StyledCardName>{getName()}</StyledCardName>
      <StyledPadCardFooter>
        <StyledPadCardDeailsDiv>
          <span>{__('Account Number')}</span>
          <StyledRoutingNumber>
            {account_number_masked
              ? displayMaskedNumber(paymentTypeId)(account_number_masked)
              : ''}
          </StyledRoutingNumber>
        </StyledPadCardDeailsDiv>
        <StyledPadCardDeailsDiv>
          <span>{__('Sort Code')}</span>
          <StyledRoutingNumber>{routing_number}</StyledRoutingNumber>
        </StyledPadCardDeailsDiv>
      </StyledPadCardFooter>
      {strDisableMessage && (
        <StyledReason>
          {strDisableMessage}
          {warningMessage && (
            <PendingAutomaticAuthorization
              plaidStatusPendingOrFailed={warningMessage}
            />
          )}
        </StyledReason>
      )}
    </StyledActionCard>
  )
}

BacsCard.propTypes = {
  alt: PropTypes.string,
  bank_info: PropTypes.any.isRequired,
  cardLabel: PropTypes.string,
  Icon: PropTypes.func.isRequired,
  img: PropTypes.string,
  nickname: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  paymentTypeId: PropTypes.number,
  src: PropTypes.string,
  isFromWallet: PropTypes.bool,
  relinkAccountId: PropTypes.number,
  isAddAutoPaymentAllowed: PropTypes.bool,
  isEditAutoPaymentAllowed: PropTypes.bool,
  isDeleteAutoPaymentAllowed: PropTypes.bool,
  deletePaymentMethodAccess: PropTypes.bool,
  addPaymentMethodAccess: PropTypes.bool,
  editPaymentMethodAccess: PropTypes.bool,
}

BacsCard.defaultProps = {
  nickname: '',
  isFromWallet: true,
}